// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.paragraph-container {
    position: relative;
    display: flex;
    align-items: flex-start;
    padding: 10px 0;
}

.paragraph-controls {
    position: absolute;
    left: -40px;
    top: 50%;
    transform: translateY(-50%);
    display: flex;
    flex-direction: column;
    gap: 8px;
    opacity: 0;
    transition: opacity 0.2s ease;
}

.paragraph-container:hover .paragraph-controls {
    opacity: 1;
}

.control-button {
    background: none;
    border: none;
    padding: 4px;
    cursor: pointer;
    color: #666;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    justify-content: center;
}

.control-button:hover {
    color: #003c4f;
    transform: scale(1.1);
}

.paragraph-content {
    flex: 1 1;
    line-height: 1.6;
    text-align: justify;
}

.loading-paragraph {
    background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
    background-size: 200% 100%;
    animation: loading 1.5s infinite;
    height: 100px;
    border-radius: 4px;
}

@keyframes loading {
    0% { background-position: 200% 0; }
    100% { background-position: -200% 0; }
}`, "",{"version":3,"sources":["webpack://./src/components/Paragraph/InteractiveParagraph.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,2BAA2B;IAC3B,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,UAAU;IACV,6BAA6B;AACjC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,WAAW;IACX,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,SAAO;IACP,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,yEAAyE;IACzE,0BAA0B;IAC1B,gCAAgC;IAChC,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,KAAK,2BAA2B,EAAE;IAClC,OAAO,4BAA4B,EAAE;AACzC","sourcesContent":[".paragraph-container {\r\n    position: relative;\r\n    display: flex;\r\n    align-items: flex-start;\r\n    padding: 10px 0;\r\n}\r\n\r\n.paragraph-controls {\r\n    position: absolute;\r\n    left: -40px;\r\n    top: 50%;\r\n    transform: translateY(-50%);\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 8px;\r\n    opacity: 0;\r\n    transition: opacity 0.2s ease;\r\n}\r\n\r\n.paragraph-container:hover .paragraph-controls {\r\n    opacity: 1;\r\n}\r\n\r\n.control-button {\r\n    background: none;\r\n    border: none;\r\n    padding: 4px;\r\n    cursor: pointer;\r\n    color: #666;\r\n    transition: all 0.2s ease;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n\r\n.control-button:hover {\r\n    color: #003c4f;\r\n    transform: scale(1.1);\r\n}\r\n\r\n.paragraph-content {\r\n    flex: 1;\r\n    line-height: 1.6;\r\n    text-align: justify;\r\n}\r\n\r\n.loading-paragraph {\r\n    background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);\r\n    background-size: 200% 100%;\r\n    animation: loading 1.5s infinite;\r\n    height: 100px;\r\n    border-radius: 4px;\r\n}\r\n\r\n@keyframes loading {\r\n    0% { background-position: 200% 0; }\r\n    100% { background-position: -200% 0; }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
